import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 文章订阅（创建）
 * @param {*} query
 */
export const subscribeCreate = (query) => {
    return request({
        url: `${prefix}/article/subscribe`,
        method: 'post',
        data: query
    })
}

/**
 * 文章订阅（查询列表）
 * @param {*} query
 */
export const articlesubscribelist = (query) => {
    return request({
        url: `${prefix}/article/subscribe/list`,
        method: 'get',
        params: query
    })
}


/**
 * 文章订阅（查询详情）
 * @param {*} query
 */
export const articlesubscribeOne = (query) => {
    return request({
        url: `${prefix}/article/subscribe`,
        method: 'get',
        params: query
    })
}


/**
 * 文章订阅（修改）
 * @param {*} query
 */
export const subscribeEdit = (query) => {
    return request({
        url: `${prefix}/article/subscribe`,
        method: 'put',
        data: query
    })
}



/**
 * 文章订阅（删除）
 * @param {*} query
 */
export const articlesubscribeRemove = (query) => {
    return request({
        url: `${prefix}/article/subscribe`,
        method: 'delete',
        data: query
    })
}

/**
 * 文章订阅（批量删除）
 * @param {*} query
 */
 export const articlesubscriblistRemove = (query) => {
    return request({
        url: `${prefix}/article/subscribe/list`,
        method: 'delete',
        data: query
    })
}

